import { AppNotification } from '@interfaces/notification';

/**
 * Sample notifications used only when `NotificationsService.useMockNotifications`
 * is enabled locally. Never shown to real users — see the service for why.
 */
export const MOCK_NOTIFICATIONS: AppNotification[] = [
  {
    id: 'mock-1',
    kind: 'ai_activity',
    body: [
      { text: 'Medullar AI', strong: true },
      { text: ' added 12 records from ' },
      { text: 'Salesforce', strong: true },
      { text: ' to Project Atlas — DD' },
    ],
    createdAt: new Date(Date.now() - 9 * 60 * 1000).toISOString(),
    read: false,
  },
  {
    id: 'mock-2',
    kind: 'member',
    actor: { name: 'Diego Martinez', initials: 'DM' },
    body: [
      { text: 'Diego Martinez', strong: true },
      { text: ' asked Medullar AI in ' },
      { text: 'Project Atlas — DD', strong: true },
    ],
    createdAt: new Date(Date.now() - 18 * 60 * 1000).toISOString(),
    read: false,
  },
  {
    id: 'mock-3',
    kind: 'member',
    actor: { name: 'Karen White', initials: 'KW' },
    body: [{ text: 'Karen White', strong: true }, { text: ' joined the workspace' }],
    createdAt: new Date(Date.now() - 60 * 60 * 1000).toISOString(),
    read: false,
  },
  {
    id: 'mock-4',
    kind: 'digest',
    body: [{ text: 'Your weekly digest is ready' }],
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    read: true,
  },
];
